// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { getHealthEnquiryAPI } from '../../../Redux/HealthRedux';

// // Styled Components
// const Section = styled.div`
//   padding: 20px;
//   background: white;
//   border-radius: 8px;
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
// `;

// const Title = styled.h2`
//   background-color: #f28c28;
//   color: white;
//   padding: 12px 20px;
//   margin: -20px -20px 20px;
//   font-size: 18px;
// `;

// const FormRow = styled.div`
//   display: flex;
//   gap: 20px;
//   flex-wrap: wrap;
// `;

// const FormGroup = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
// `;

// const Label = styled.label`
//   font-weight: bold;
//   span {
//     color: red;
//     margin-left: 3px;
//   }
// `;

// const Input = styled.input`
//   padding: 10px;
//   border: 1px solid ${({ error }) => (error ? 'red' : '#ccc')};
//   border-radius: 4px;
//   margin-top: 5px;
// `;

// const ErrorText = styled.span`
//   color: red;
//   font-size: 12px;
// `;

// const Select = styled.select`
//   padding: 10px;
//   margin-top: 5px;
//   border: 1px solid ${({ error }) => (error ? 'red' : '#ccc')};
//   border-radius: 4px;
// `;

// const Button = styled.button`
//   margin-top: 20px;
//   padding: 10px 25px;
//   background-color: #f28c28;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   font-weight: bold;
//   cursor: pointer;
// `;

// // Component
// const InsuredDetails = ({
//   members,
//   setMembers,
//   enquiryId,
//   errors,
//   onContinue,
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

// const { isFetching, septateCombinedRedux, error, success } = useSelector(
//   (state) => state.health
// );

//   // Flatten insuredMembers[0] into members[]
// useEffect(() => {

//   console.log('🚀 ~ isFetching, error, success:', isFetching, error, success);
//   const rawMembers = septateCombinedRedux?.insuredMembers;

//   // If it's already set, avoid re-setting
//   if (members?.length === 0 && rawMembers) {
//     let entries = [];

//     if (Array.isArray(rawMembers)) {
//       entries = rawMembers[0] ? Object.entries(rawMembers[0]) : [];
//     } else if (typeof rawMembers === 'object' && rawMembers !== null) {
//       entries = Object.entries(rawMembers);
//     }

//     const flatMembers = entries.flatMap(([_, val]) => {
//       if (Array.isArray(val)) return val; // handle child array
//       if (typeof val === 'object' && val !== null) return [val]; // handle object
//       return []; // ignore primitives
//     });
//     console.log("🚀 ~ flatMembers ~ flatMembers:", flatMembers)

//     setMembers(flatMembers);
//   }
// }, [members?.length, septateCombinedRedux?.insuredMembers, success]);


//   useEffect(() => {
//     if (enquiryId) {
//       dispatch(getHealthEnquiryAPI({ enquiryId }));
//     }
//   }, [enquiryId, dispatch]);

//   const handleFieldChange = (index, key, value) => {
//     const updated = [...members];
//     updated[index] = { ...updated[index], [key]: value };
//     setMembers(updated);
//   };

//   const handleNomineeChange = (index, key, value) => {
//     const updated = [...members];
//     updated[index] = {
//       ...updated[index],
//       nominee: {
//         ...updated[index].nominee,
//         [key]: value,
//       },
//     };
//     setMembers(updated);
//   };

//   const renderMemberForm = (values, index) => (
//     <>
//       <FormRow>
//         <FormGroup>
//           <Label>
//             First Name<span>*</span>
//           </Label>
//           <Input
//             value={values.firstName}
//             onChange={(e) =>
//               handleFieldChange(index, 'firstName', e.target.value)
//             }
//             error={errors.firstName}
//             placeholder="Enter First Name"
//           />
//           {errors.firstName && <ErrorText>First name required</ErrorText>}
//         </FormGroup>

//         <FormGroup>
//           <Label>
//             Last Name<span>*</span>
//           </Label>
//           <Input
//             value={values.lastName}
//             onChange={(e) =>
//               handleFieldChange(index, 'lastName', e.target.value)
//             }
//             error={errors.lastName}
//             placeholder="Enter Last Name"
//           />
//           {errors.lastName && <ErrorText>Last name required</ErrorText>}
//         </FormGroup>

//         <FormGroup>
//           <Label>
//             Date of Birth<span>*</span>
//           </Label>
//           <Input
//             type="date"
//             value={values.dob?.split('T')[0] || ''}
//             onChange={(e) => handleFieldChange(index, 'dob', e.target.value)}
//             error={errors.dob}
//           />
//           {errors.dob && <ErrorText>Date of birth required</ErrorText>}
//         </FormGroup>
//       </FormRow>

//       <FormRow>
//         <FormGroup>
//           <Label>
//             Occupation<span>*</span>
//           </Label>
//           <Select
//             value={values.occupation}
//             onChange={(e) =>
//               handleFieldChange(index, 'occupation', e.target.value)
//             }
//             error={errors.occupation}
//           >
//             <option value="">Select Occupation</option>
//             <option value="Engineer">Engineer</option>
//             <option value="Teacher">Teacher</option>
//             <option value="Doctor">Doctor</option>
//             <option value="Student">Student</option>
//             <option value="Retired">Retired</option>
//             <option value="Housewife">Housewife</option>
//             <option value="Lawyer">Lawyer</option>
//             <option value="Business">Business</option>
//             <option value="Other">Other</option>
//           </Select>
//           {errors.occupation && <ErrorText>Occupation required</ErrorText>}
//         </FormGroup>

//         <FormGroup>
//           <Label>Height (cm)</Label>
//           <Input
//             type="number"
//             value={values.height || ''}
//             onChange={(e) => handleFieldChange(index, 'height', e.target.value)}
//             placeholder="Enter Height"
//           />
//         </FormGroup>

//         <FormGroup>
//           <Label>Weight (kg)</Label>
//           <Input
//             type="number"
//             value={values.weight || ''}
//             onChange={(e) => handleFieldChange(index, 'weight', e.target.value)}
//             placeholder="Enter Weight"
//           />
//         </FormGroup>
//       </FormRow>

//       <FormRow>
//         <FormGroup>
//           <Label>Nominee Name</Label>
//           <Input
//             value={values.nominee?.name || ''}
//             onChange={(e) => handleNomineeChange(index, 'name', e.target.value)}
//             placeholder="Enter Nominee Name"
//           />
//         </FormGroup>

//         <FormGroup>
//           <Label>Nominee Relation</Label>
//           <Input
//             value={values.nominee?.relation || ''}
//             onChange={(e) =>
//               handleNomineeChange(index, 'relation', e.target.value)
//             }
//             placeholder="Enter Nominee Relation"
//           />
//         </FormGroup>

//         <FormGroup>
//           <Label>Nominee DOB</Label>
//           <Input
//             type="date"
//             value={values.nominee?.dob || ''}
//             onChange={(e) => handleNomineeChange(index, 'dob', e.target.value)}
//           />
//         </FormGroup>
//       </FormRow>
//     </>
//   );

//   return (
//     <>
//       {members.map((member, index) => (
//         <Section key={index}>
//           <Title>
//             {member.relation?.charAt(0).toUpperCase() +
//               member.relation?.slice(1)}{' '}
//             Details
//           </Title>
//           {renderMemberForm(member, index)}
//         </Section>
//       ))}
//       <Button onClick={onContinue}>Continue</Button>
//     </>
//   );
// };

// export default InsuredDetails;


import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getHealthEnquiryAPI } from '../../../Redux/HealthRedux';
const { calculateAge } = require('../../../utilities/calculateAge');

// Styled Components
const Section = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  background-color: #f28c28;
  color: white;
  padding: 12px 20px;
  margin: -20px -20px 20px;
  font-size: 18px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: bold;
  span {
    color: red;
    margin-left: 3px;
  }
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ccc')};
  border-radius: 4px;
  margin-top: 5px;
`;

const ErrorText = styled.span`
  color: red;
  font-size: 12px;
`;

const Select = styled.select`
  padding: 10px;
  margin-top: 5px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ccc')};
  border-radius: 4px;
`;

const Button = styled.button`
  margin-top: 20px;
  padding: 10px 25px;
  background-color: ${({ disabled }) => (disabled ? '#ccc' : '#28a745')};
  color: ${({ disabled }) => (disabled ? '#666' : 'white')};
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ disabled }) => (disabled ? '#ccc' : '#218838')};
  }
`;

export function calculateBMI(heightCm, weightKg) {
  if (!heightCm || !weightKg || heightCm <= 0 || weightKg <= 0) return null;
  const heightM = heightCm / 100;
  const bmi = weightKg / (heightM * heightM);
  return +bmi.toFixed(2);
}

export function getBMICategory(bmi) {
  if (bmi === null) return null;
  if (bmi >= 0 && bmi <= 18.4) return 'Decline';
  if (bmi >= 18.5 && bmi <= 32.0) return 'STP';
  if (bmi >= 32.1 && bmi < 33.0) return 'Loading';
  if (bmi >= 33.0) return 'Decline';
  return null;
}

const InsuredDetails = ({
  members,
  setMembers,
  enquiryId,
  errors,
  onContinue,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isFetching, septateCombinedRedux, error, success } = useSelector(
    (state) => state.health
  );


useEffect(() => {
  const rawMembers = septateCombinedRedux?.insuredMembers;

  // If it's already set, avoid re-setting
  if (rawMembers) {
    let entries = [];

    // Check if rawMembers is an array or an object and convert it into entries
    if (Array.isArray(rawMembers)) {
      entries = rawMembers[0] ? Object.entries(rawMembers[0]) : [];
    } else if (typeof rawMembers === 'object' && rawMembers !== null) {
      entries = Object.entries(rawMembers);
    }

    // Flatten the entries and map over them
    const flatMembers = entries.flatMap(([_, val]) => {
      if (Array.isArray(val)) return val;
      if (typeof val === 'object' && val !== null) return [val];
      return [];
    });
    
    // Group members by their relation
    const groupedMembers = flatMembers.reduce((acc, member) => {
      const relation = member.relation || 'self';

      // Directly assign the member data to the relation key
      acc[relation] = {
        firstName: member.firstName || '',
        lastName: member.lastName || '',
        occupation: member.occupation || '',
        dob: member.dob || '',
        gender: member.gender || '',
        height: member.height || '',
        weight: member.weight || '',
        NomineeName: member.NomineeName || '',
        NomineeRelation: member.NomineeRelation || '',
        NomineeDob: member.NomineeDob || '',
        relation: member.relation || 'self',
      };

      return acc;
    }, {});
    
    setMembers(groupedMembers);
  }
}, [septateCombinedRedux?.insuredMembers, success]);


  useEffect(() => {
    if (enquiryId) {
      dispatch(getHealthEnquiryAPI({ enquiryId }));
    }
  }, [enquiryId, dispatch]);


  const handleFieldChange = (relation, key, value) => {
    const updated = {
      ...members,
      [relation]: {
        ...members[relation],
        [key]: value,
      },
    };

    setMembers(updated); 
  };

  const membersWithBMI = Object.entries(members).map(([relation, member]) => {
    const heightNum = parseFloat(member.height) || 0;
    const weightNum = parseFloat(member.weight) || 0;

    // Calculate age from date of birth
    const age = calculateAge(member.dob);

    // const bmi = calculateBMI(heightNum, weightNum);
    // const category = getBMICategory(bmi);

    let bmi = null;
    let category = null;

    if (age >= 16) {
      bmi = calculateBMI(heightNum, weightNum);
      category = getBMICategory(bmi);
    }

    return {
      relation,
      bmi,
      category,
      fullName: `${member.firstName || ''} ${member.lastName || ''}`.trim(),
      age,
    };
  });

  // Find members with Decline BMI
  const declinedMembers = membersWithBMI.filter(
    (m) => m.category === 'Decline'
  );
  const isContinueDisabled = declinedMembers.length > 0;

  const getCategoryStyle = (category) => {
    switch (category) {
      case 'Loading':
        return { color: 'orange', fontWeight: 'bold' };
      case 'Decline':
        return { color: 'red', fontWeight: 'bold' };
      case 'STP':
        return { color: 'green', fontWeight: 'bold' };
      default:
        return { fontWeight: 'bold' };
    }
  };
  

  const renderMemberForm = (values, index) => {
    const bmiValue = calculateBMI(
      parseFloat(values.height),
      parseFloat(values.weight)
    );
    const categoryValue = getBMICategory(bmiValue);
    const age = calculateAge(values.dob);

    return (
      <>
        <FormRow>
          <FormGroup>
            <Label>
              First Name<span>*</span>
            </Label>
            <Input
              value={values.firstName}
              onChange={(e) =>
                handleFieldChange(values.relation, 'firstName', e.target.value)
              }
              error={errors[`${values.relation}-firstName`]} // Dynamically check the error based on relation
              placeholder="Enter First Name"
            />
            {errors[`${values.relation}-firstName`] && (
              <ErrorText>First name required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Last Name<span>*</span>
            </Label>
            <Input
              value={values.lastName}
              onChange={(e) =>
                handleFieldChange(values.relation, 'lastName', e.target.value)
              }
              error={errors[`${values.relation}-lastName`]}
              placeholder="Enter Last Name"
            />
            {errors[`${values.relation}-lastName`] && (
              <ErrorText>Last name required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Date of Birth<span>*</span>
            </Label>
            <Input
              type="date"
              min="1900-01-01"
              max="2099-12-31"
              value={values.dob?.split('T')[0] || ''}
              onChange={(e) =>
                handleFieldChange(values.relation, 'dob', e.target.value)
              }
              error={errors[`${values.relation}-dob`]} // Dynamically check the error for dob
            />
            {errors[`${values.relation}-dob`] && (
              <ErrorText>Date of birth required</ErrorText>
            )}
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup>
            <Label>
              Occupation<span>*</span>
            </Label>
            <Select
              value={values.occupation}
              onChange={(e) =>
                handleFieldChange(values.relation, 'occupation', e.target.value)
              }
              error={errors[`${values.relation}-occupation`]}
            >
              <option value="">Select Occupation</option>
              <option value="Engineer">Engineer</option>
              <option value="Teacher">Teacher</option>
              <option value="Doctor">Doctor</option>
              <option value="Student">Student</option>
              <option value="Retired">Retired</option>
              <option value="Housewife">Housewife</option>
              <option value="Lawyer">Lawyer</option>
              <option value="Business">Business</option>
              <option value="Other">Other</option>
            </Select>
            {errors[`${values.relation}-occupation`] && (
              <ErrorText>Occupation required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Height (cm)<span>*</span>
            </Label>
            <Input
              type="number"
              value={values.height || ''}
              onChange={(e) =>
                handleFieldChange(values.relation, 'height', e.target.value)
              }
              placeholder="Enter Height"
            />
            {errors[`${values.relation}-height`] && (
              <ErrorText>Height required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Weight (kg)<span>*</span>
            </Label>
            <Input
              type="number"
              value={values.weight || ''}
              onChange={(e) =>
                handleFieldChange(values.relation, 'weight', e.target.value)
              }
              placeholder="Enter Weight"
            />
            {errors[`${values.relation}-weight`] && (
              <ErrorText>Weight required</ErrorText>
            )}
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup>
            <Label>
              Nominee Name<span>*</span>
            </Label>
            <Input
              value={values.NomineeName || ''}
              onChange={(e) =>
                handleFieldChange(
                  values.relation,
                  'NomineeName',
                  e.target.value
                )
              }
              placeholder="Enter Nominee Name"
            />
            {errors[`${values.relation}-NomineeName`] && (
              <ErrorText>Nominee name required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Nominee Relation<span>*</span>
            </Label>
            <Select
              value={values.NomineeRelation || ''}
              onChange={(e) =>
                handleFieldChange(
                  values.relation,
                  'NomineeRelation',
                  e.target.value
                )
              }
            >
              <option value="">Select Nominee Relation</option>
              <option value="SPOU">Spouse</option>
              <option value="FATH">Father</option>
              <option value="MOTH">Mother</option>
              <option value="SON">Son</option>
              <option value="DAUG">Daughter</option>
            </Select>
            {errors[`${values.relation}-NomineeRelation`] && (
              <ErrorText>Nominee relation required</ErrorText>
            )}
          </FormGroup>

          <FormGroup>
            <Label>
              Nominee DOB<span>*</span>
            </Label>
            <Input
              type="date"
              min="1900-01-01"
              max="2099-12-31"
              value={values.NomineeDob || ''}
              onChange={(e) =>
                handleFieldChange(values.relation, 'NomineeDob', e.target.value)
              }
            />
            {errors[`${values.relation}-NomineeDob`] && (
              <ErrorText>Nominee DOB required</ErrorText>
            )}
          </FormGroup>
        </FormRow>
        {age >= 16 && (
          <>
            <div style={{ marginTop: '1rem' }}>
              <strong>BMI:</strong>{' '}
              <span style={getCategoryStyle(categoryValue)}>
                {bmiValue ?? '0'}
              </span>
            </div>
            <div>
              <strong>Category:</strong>{' '}
              <span style={getCategoryStyle(categoryValue)}>
                {categoryValue || 'N/A'}
              </span>
            </div>
          </>
        )}
      </>
    );
};

  return (
    <>
      {Object.entries(members).map(([relation, member], index) => (
        <Section key={index}>
          <Title>
            {isFetching ? (
              <div>Loading...</div> // Show loading state when isFetching is true
            ) : error ? (
              <div>Error loading data</div> // Show error state if any error occurs
            ) : (
              relation.charAt(0).toUpperCase() + relation.slice(1) // Capitalize the relation key (e.g., 'self' -> 'Self')
            )}
            Details
          </Title>
          {isFetching ? (
            <div>Loading...</div> // Show loading state when isFetching is true
          ) : error ? (
            <div>Error loading data</div> // Show error state if any error occurs
          ) : (
            renderMemberForm(member, index) // Pass member data to renderMemberForm
          )}
        </Section>
      ))}

      {isContinueDisabled && (
        <div style={{ color: 'red', marginTop: '1rem' }}>
          Warning: Decline BMI detected for{' '}
          {declinedMembers.map((m) => m.fullName || m.relation).join(', ')}
        </div>
      )}

        <Button onClick={onContinue} disabled={isContinueDisabled}>
          Continue
        </Button>
    </>
  );
};

export default InsuredDetails;